export { default as SingleUserIcon } from "./singleUser";
